<template>
  <div id="footer">
    <div class="footer_wrap">
      <div class="footer_contents">
        <div class="sns_btn_group">
          <a class="sns_btn yt" :href="location('yt')" target="_blank" rel="nofollow"></a>
          <a class="sns_btn is" :href="location('is')" target="_blank" rel="nofollow"></a>
					<a class="sns_btn na" :href="location('na')" target="_blank" rel="nofollow"></a>
        </div>
      </div>
      <div class="footer_contents">
        <div class="footer_item">
          <div class="sub_link" 
              v-for="(link, idx) in links" 
              :key="`sub_menu_${idx}`">
            <a :class="{active: currentPage == link.path}" :href="link.path"> {{link.name}} </a>
          </div>
        </div>
        <div class="footer_item">
          <span> 1833-8910 (평일 09:00 ~ 18:00) </span>
          <span> (주)스포티비 | 대표 : 오희철 </span>
          <span> 03924 서울시 마포구 월드컵북로 56길 12 상암동 TRUTEC 빌딩 5층 </span>
        </div>
        <div class="footer_item">
          <span> Copyright ⓒ 2024 SPOTV K. All rights reserved</span>
        </div>
      </div>
      <div class="footer_contents">
        <div class="footer_logo" @click="$router.push('/').catch(()=>{})"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "@/helpers/utils";
export default {
	name: "Footer",
	components: {

	},
	data() {
		return {
			currentPage: null,
			links: [
				{name: "광고문의", path: "/advertise"},
				{name: "사업제휴문의", path: "/contact"},
				{name: "오시는 길", path: "/location"},
			]
		}
	},
	created() {
		this.checkActive(this.$route.path)
	},
	methods: {
		location(type) {
			let link = Utils.getSns()[type]
			// window.open(link,'_blank')
			return link
		},
		move(path) {
			this.currentPage = path
			this.$router.replace(`${path}`).catch(()=>{})
		},
		checkActive(path) {
			if(_.some(this.links, {path: path})) {
				this.currentPage = path
			} else {
				this.currentPage = null
			}
		}
	},
	watch: {
		'$route'(to, from) {
			this.checkActive(to.path)
		}
	}
}
</script>
<style lang="less">
#footer {
	margin: auto;
	width: 100%;
	min-width: 1400px;
	max-width: 1920px;
	background-color: #F8F8F8;
	.footer_wrap {
		margin: auto;
		padding-top: 50px;
		padding-bottom: 100px;
		width: 453px;
		display: flex;
		justify-content: center;
		flex-flow: column wrap;
		border-top: 1px solid #FFFFFF;
		.footer_contents {
			display: flex;
			flex-flow: column wrap;
			align-items: center;
			justify-content: center;
			transform: skew(-0.05deg);
			.footer_logo {
				width: 206px;
				height: 60px;
				background-image: url("~@/assets/image/footer/statv_logo_footer.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				background-position: center;
				margin-top: 30px;
				cursor: pointer;
			}
    	 	.footer_item {
				width: 100%;
				display: flex;
				justify-content: center;
				flex-flow: row wrap;
				color: #8F8F8F;
				font-size: 16px;
				font-weight: 400;
				&:nth-child(2) {
					flex-direction: column;
					align-items: center;
				}
				.sub_link {
					flex: 1 0 auto;
					text-align: center;
					font-size: 20px;
					font-weight: 600;
					margin: 20px 0;
					cursor: pointer;
					> a {
						color: #8F8F8F;
						&.active {
							color: #ff0043;
						}
					}
				}
			}
			.sns_btn_group {
				display: flex;
				justify-content: center;
				.sns_btn {
					background-repeat: no-repeat;
					background-position: center;
					background-size: 100% 100%;
					width: 45px;
					height: 45px;
					margin: 0 28px;
					cursor: pointer;
					transition: background-image 0.3s ease-in-out;
					&.yt {
						background-image: url("~@/assets/image/footer/youtube_logo_gray_footer.png");
						&:hover {
							background-image: url("~@/assets/image/footer/youtube_logo_color_footer.png");
						}
					}
					&.is{
						background-image: url("~@/assets/image/footer/insta_logo_gray_footer.png");
						&:hover {
							background-image: url("~@/assets/image/footer/insta_logo_color_footer.png");
						}
					}
					&.na {
						background-image: url("~@/assets/image/footer/navertv_logo_gray_footer.png");
						&:hover {
							background-image: url("~@/assets/image/footer/navertv_logo_color_footer.png");
						}
					}
				}
			}
		}
	}
}
.m #footer {
	max-width: 765px;
	min-width: 345px;
	background-color: #f8f8f8;
	.footer_wrap {
		padding-top: 0 !important;
		padding-bottom: 75px !important;
		width: calc(100vw - 60px);
		border-top: none;
		.footer_contents {
			.footer_logo {
				margin-top: 75px;
				background-image: url("~@/assets/image/footer/STATV_logo_footer_m.png");
			}
			.footer_item {
				font-size: 24px;
				color: #717171;
				line-height: 1.4;
				transform: skew(1deg);
				.sub_link {
					font-size: 29px;
					font-weight: 900;
					margin: 0 0 50px;
					padding: 20px 0;
				}
			}
			.sns_btn_group {
				display: none;
			}
		}
	}
}
</style>